import apiClient from '../api';

export const createProject = (data) => apiClient.post(`/project`, data);
export const createMultipleProject = (data) => apiClient.post(`/project/add/multiple/projects`, data);

export const approveProject = (id, data, header) => apiClient.put(`/project/stage/approve/${id}`, data, header);

export const updateProjectTopic = (id, data, header) => apiClient.put(`/project/stage/topic/update/${id}`, data, header);

export const getSingleProject = (id) => apiClient.get(`/project/${id}`);

export const getProjectList = (data) => apiClient.get(`/project/list/${data.id}/${data.userId}`);

export const deleteProject = (id) => apiClient.delete(`/project/delete/${id}`);

export const uploadVoiceOverFile = (id,data, header) => apiClient.post(`/project/stage/vo/file/${id}`, data, header);

export const uploadProjectVideoFile = (id,data, header) => apiClient.post(`/project/stage/video/file/${id}`, data, header);

export const uploadProjectVerticalVideoFile = (id,data, header) => apiClient.post(`/project/stage/video/vertical/file/${id}`, data, header);

export const uploadProjectScriptFile = (id,data, header) => apiClient.post(`/project/stage/script/file/${id}`, data, header);
export const uploadProjectScriptFileStg = (id,data, header) => apiClient.post(`/project/stage/script/file/stg/${id}`, data, header);

export const addUserToProject = (id, data, header) => apiClient.put(`/project/associated/user/add/${id}`, data, header);

export const downloadVimeoVideo = (id) => apiClient.get(`/project/download/video/${id}`);

export const getProjectTaskList = (header) => apiClient.get(`/project/task/list`, header);

export const uploadVisualNotesFile = (id,data, header) => apiClient.post(`/project/upload/visual/note/${id}`, data, header);

export const editVisualFiles = (id, data, header) => apiClient.put(`/project/edit/visual-files/${id}`, data, header);

export const getVisualFilesByProjectIdAndTopicId = (ids, header) => apiClient.get(`/project/get/visual/files/${ids.projectId}/${ids.topicId}`, header);

export const uploadSceneImages = (id, data, header) => apiClient.post(`/project/upload/scene/images/${id}`, data, header);

export const getSceneImagesByProjectIdAndTopicId = (ids, header) => apiClient.get(`/project/get/scene/images/${ids.projectId}/${ids.topicId}`, header);

export const deleteSceneFile = (sceneFileId, fileId, header) => apiClient.delete(`/project/delete/single/scene-files/${sceneFileId}/${fileId}`, header);

export const deleteVisualFile = (visualNoteId, fileId, header) => apiClient.delete(`/project/delete/single/visual-files/${visualNoteId}/${fileId}`, header);

export const deleteVisualNoteWithFiles = (visualNoteId, header) => apiClient.delete(`/project/delete/visual-files/note/${visualNoteId}`, header);

export const updateProjectDetails = (projectId, data, header) => apiClient.put(`/project/detail/update/${projectId}`, data, header);

export const getVimeoReviewPageLink = (videoId, header) => apiClient.get(`/project/generate/video/vimeo/review/link/${videoId}`, header);

export const getVimeoVideoDownloadLinks = (videoId, header) => apiClient.get(`/project/get/video/vimeo/download/links/${videoId}`, header);
// HeyGen generation and status
export const generateHeygenVideos = (id, header) => apiClient.post(`/project/generate/heygen/${id}`, {}, header);
export const getProjectVideoVersionStatusById = (versionId, header) => apiClient.get(`/project/video-version/status/${versionId}`, header);
export const getProjectVideoVersionStatusByProjectAndVersion = (projectId, versionNumber, header) => apiClient.get(`/project/video-version/status?projectId=${projectId}&versionNumber=${versionNumber}`, header);
export const getProjectVideoVersionStatusByProject = (projectId, header) => apiClient.get(`/project/video-version/status?projectId=${projectId}`, header);